/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const newKioskDrumWrfSchema = z.object({
	accent_color: z.string().nullable(),
	background_color: z.string().nullable(),
	is_image: z.boolean(),
});
